import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { utils, comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl, Tab } from "@/comn/components"; // 화면 구성 컴포넌트
import {
    useFetch,
    useForm,
    useGrid,
    useStore,
    useToast,
    useResource,
    useModal,
    usePage,
    usePopup,
    useTab,
    useFieldArray,
} from "@/comn/hooks";
import {
    APIS,
    CO_CD_EXCL_SET,
    SF_USR_APLY_INFO,
    SG_CO_TP_APLY_LIST,
    SF_CO_TP_INFO,
    FIELD_VISIBILITY_MAP,
    ATCH_FILE_VISIBILITY_MAP,
    CO_CD_INPUT_TRGT_SET,
    CO_CD_INPUT_PROPERTIES,
    SG_CO_EMP_LIST,
    SF_CO_EMP_INFO,
    URLS,
    CO_CD_LCNE_SET,
} from "@/tra/tancis/ptli/usr/co/services/PtliCoService";

import { getNameOfJSDocTypedef } from "typescript";

/*
 * Company Registration
 * !== 업체 등록 ==!
 */
export const PTLI0905002S = (): JSX.Element => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { openPopup } = usePopup();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast();
    const [lcneNoIssCoTpList, setLcneNoIssCoTpList] = useState<string[]>([]);
    //const lcmWrhsCoTpMapRef = useRef<any>({});
    const [lcmWrhsCoTpMapRef, setLcmWrhsCoTpMapRef] = useState<any>({});

    // 선택된 행의 타입 정의
    interface RowData {
        [key: string]: any; // 또는 실제 데이터 필드들 정의
    }

    // 선택된 행 상태 관리
    const [selectedCoCdRow, setSelectedCoCdRow] = useState<RowData | null>(null);
    const [coCdGridData, setCoCdGridData] = useState<RowData[]>([]);
    const [coTinCntyChk, setCoTinCntyChk] = useState(false);

    const [epzPrmss, setEpzPrmss] = useState<any>({});

    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "COM0011" },
            { area: "comnCd", comnCd: "CGM0095" },
            { area: "comnCd", comnCd: "CGM0096" },
            { area: "comnCd", comnCd: "PTL0001" },
            { area: "cstmCd" },
            { area: "cntyCd" },
        ],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // User Information !== 사용자(대표자) 정보 ==!
        usrAplyInfo: useForm({
            defaultSchema: SF_USR_APLY_INFO,
        }),
        coTpFormList: useForm({
            defaultSchema: SF_CO_TP_INFO,
        }),
        coEmpInfo: useForm({
            defaultSchema: SF_CO_EMP_INFO,
        }),
    };

    const { fields, remove, append, prepend, insert } = useFieldArray(form.coTpFormList.schema.coTpArray);

    // Organization, Department Tab !== 기관,부서 탭 ==!
    const tab = useTab({
        defaultSchema: {
            id: "tab",
            schema: [{ label: "L_CO_INFO" }, { label: "L_CO_CD" }],
        },
    });

    const grid = {
        // Company Type List !== 업체 유형 목록 ==!
        coTpList: useGrid({
            defaultSchema: SG_CO_TP_APLY_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
        coEmpList: useGrid({
            defaultSchema: SG_CO_EMP_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };
    const coTin = form.usrAplyInfo.watch("coTin");
    const xtrnUsrIdntfNo = form.usrAplyInfo.watch("xtrnUsrIdntfNo");

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getTinNoLstForCo: useFetch({
            api: () => {
                return APIS.getPayerTinNoLst(coTin, "Y");
            },
            // enabled: !!coTin,
            // key: [coTin],
            onSuccess: (data) => {
                const tinNoList = data.tinNoList.content;

                if (tinNoList.length == 1) {
                    const tinNoInfo = tinNoList[0];
                    form.usrAplyInfo.setValue("coTin", tinNoInfo.tinNo);
                    form.usrAplyInfo.setValue("coNm", tinNoInfo.coNm);
                    form.usrAplyInfo.setValue("rprsTelno", tinNoInfo.rprsTelno);
                    form.usrAplyInfo.setValue("rprsFaxNo", tinNoInfo.rprsFaxNo);
                    form.usrAplyInfo.setValue("rprsEml", tinNoInfo.rprsEml);
                    form.usrAplyInfo.setValue("coAddr", tinNoInfo.coAddr);

                    fetch.getLcmWrhsCoTpMap.fetch(tinNoInfo.tinNo);
                    fetch.getEpzLcnePrmssInfo.fetch(coTin);
                    fetch.getCoTinCntyCheck.fetch(coTin);
                } else {
                    toast.showToast({ type: "error", content: "msg.clr.00004" });
                }
            },
        }),
        getTinNoLstForUsr: useFetch({
            api: () => {
                return APIS.getPayerTinNoLst(xtrnUsrIdntfNo, "N");
            },
            // enabled: !!coTin,
            // key: [coTin],
            onSuccess: (data) => {
                const tinNoList = data.tinNoList.content;

                if (tinNoList.length == 1) {
                    const tinNoInfo = tinNoList[0];

                    form.usrAplyInfo.setValue("xtrnUsrIdntfNo", tinNoInfo.tinNo);
                    form.usrAplyInfo.setValue("usrNm", tinNoInfo.coNm);
                    form.usrAplyInfo.setValue("usrMoblNo", tinNoInfo.rprsTelno);
                    form.usrAplyInfo.setValue("rsdtAddr", tinNoInfo.coAddr);
                    form.usrAplyInfo.setValue("usrEmlAddr", tinNoInfo.rprsEml);

                    handler.checkUsrTin();
                } else {
                    toast.showToast({ type: "error", content: "msg.clr.00004" });
                }
            },
        }),
        // Save User Information !==  사용자 정보 저장 ==!
        saveCoUsr: useFetch({
            api: (data) => APIS.createUsr(data),
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.com.00062", // Successfully saved., !== 정상적으로 저장되었습니다. ==!
                    onConfirm: () => {
                        // navigate("/registration");
                    },
                    close: false,
                });
                const coUsr = data.coUsr.content;
                navigate(`${URLS.ptli0905004q}/${coUsr.coTin}`);
            },
            onError: (error) => {
                console.log(error);
                const data = error.response.data;
                modal.openModal({
                    content: data.errorMessage,
                });
            },
        }),

        // User Tin duplicate check !== 사용자 TIN 중복 체크 ==!
        getCoDuplCheck: useFetch({
            api: (data: any) => APIS.getCoDuplCheck(data),
            enabled: false,
            onSuccess: (data) => {
                form.usrAplyInfo.clearErrors("xtrnUsrIdntfNo");

                const coUsrInfo = data.coUsrInfo.content;

                if (!comnUtils.isEmpty(coUsrInfo)) {
                    if (coUsrInfo.coUsrYn === "Y") {
                        form.usrAplyInfo.setError("xtrnUsrIdntfNo", {
                            message: "msg.com.00107", // Already registered user. !== 이미 등록된 사용자입니다. ==!
                            type: "error",
                        });

                        form.usrAplyInfo.setValue("usrNm", null);
                        form.usrAplyInfo.setValue("frgnrYn", null);
                        form.usrAplyInfo.setValue("aplcCntyCd", null);
                        form.usrAplyInfo.setValue("usrMoblNo", null);
                        form.usrAplyInfo.setValue("rsdtAddr", null);
                        form.usrAplyInfo.setValue("usrEmlAddr", null);

                        form.usrAplyInfo.setValue("xtrnUsrRgsrYn", "N");
                    } else {
                        form.usrAplyInfo.setValue("usrNm", coUsrInfo.usrNm);
                        form.usrAplyInfo.setValue("frgnrYn", coUsrInfo.frgnrYn);
                        form.usrAplyInfo.setValue("aplcCntyCd", coUsrInfo.aplcCntyCd);
                        form.usrAplyInfo.setValue("usrMoblNo", coUsrInfo.usrMoblNo);
                        form.usrAplyInfo.setValue("usrEmlAddr", coUsrInfo.usrEmlAddr);
                        form.usrAplyInfo.setValue("rsdtAddr", coUsrInfo.rsdtAddr);

                        form.usrAplyInfo.setValue("xtrnUsrRgsrYn", "Y");
                    }
                } else {
                    form.usrAplyInfo.setValue("xtrnUsrRgsrYn", "N");
                }
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        // Get License User Information !== 면허 사용자 정보 조회 ==!
        getLcmWrhsCoTpMap: useFetch({
            api: (coTin: string) => APIS.getLcmWrhsCoTpMap(coTin),
            onSuccess: (data) => {
                const lcmCotpMap = data.lcmWrhsCotpMap.content;
                setLcmWrhsCoTpMapRef(lcmCotpMap);
                //lcmWrhsCoTpMapRef.current = lcmCotpMap;
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
            showToast: true,
        }),
        // Get EPZ License Permission Information !== EPZ 면허 허가 정보 ==!
        getEpzLcnePrmssInfo: useFetch({
            api: (coTin: string) => APIS.getEpzLcnePrmssInfo(coTin),
            onSuccess: (data) => {
                const epzLcnePrmssInfo = data.epzLcnePrmssInfo.content;
                setEpzPrmss(epzLcnePrmssInfo);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
            showToast: true,
        }),

        getCoTinCntyCheck: useFetch({
            api: (data: any) => APIS.getCoTinCntyCheck(data),
            enabled: false,
            onSuccess: (data) => {
                if (data.coTinCntyCheck.content) {
                    // TZA가 아니면 1을 출력하고, TZA 이면 0을 출력함
                    setCoTinCntyChk(true);
                } else {
                    // TZA 일 때,
                    setCoTinCntyChk(false);
                }
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const render = {
        coTpList: {
            cell: {
                cstmOfceCdd: (props: any) => {
                    const { binding, rowValues, value } = props;

                    const cstmOfceNm = utils.getCodeLabel("cstmCd", value);

                    return `${value}, ${cstmOfceNm}`;
                },
            },
        },
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Company Employee List Cell Click  !== 업체 직원 목록 셀 클릭 ==!
        onCoEmpListRowClick: (data: any) => {
            form.coEmpInfo.setValues(data);
        },
        // on Save Button Click Event Handler  !== 알림 등록 ==!
        onSaveBtnClick: () => {
            if (coTinCntyChk && form.usrAplyInfo.getValue("aplcCntyCd") === "TZ") {
                // true =?> TZA가 아닌데 국가 코드가 TZ 일때 block
                toast.showToast({ type: "warning", content: "msg.ptl.00830" });
                return;
            }

            modal.openModal({
                content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                onConfirm: () => {
                    if (!comnUtils.isEmpty(form.usrAplyInfo.errors)) {
                        toast.showToast({
                            type: "warning",
                            content: t("msg.ptl.00682", { 0: t("T_CO_INFO") + " TAB" }),
                        }); // Please check the required entries for {0} !== {0}의 필수입력 항목을 확인하시기 바랍니다. ==!
                        return;
                    }
                    form.usrAplyInfo.handleSubmit(
                        () => {
                            if (!comnUtils.isEmpty(form.coTpFormList.errors)) {
                                handler.showValidMsg();
                                return;
                            }

                            // Check for Company Code Duplicate !== 업체 유형 중복 확인 ==!
                            const coTpArray = form.coTpFormList.getValues("coTpArray");
                            if (
                                coTpArray.some((item: any, index: any, self: any) => {
                                    return (
                                        (!CO_CD_LCNE_SET.has(item.coTpCd) ||
                                            (item.coTpCd === "C" && item.coTpCd === "CS")) &&
                                        //(!CO_CD_LCNE_SET.has(item.coTpCd) || item.coTpCd === "C") &&
                                        //whsCoTpCds.indexOf(item.coTpCd) === -1 &&
                                        index !==
                                            self.findIndex(
                                                (v: any) =>
                                                    v.cstmOfceCd === item.cstmOfceCd && v.coTpCd === item.coTpCd,
                                            )
                                    );
                                })
                            ) {
                                toast.showToast({
                                    type: "warning",
                                    content: t("msg.cgm.00383", { 0: t("L_CO_TP") + ", " + t("L_CSTM_OFCE_CD") }),
                                }); // Duplicate data exists. {0: Company Type, Customs Office Code} !== 중복된 데이터가 존재합니다. {0: 업체 타입, 세관 사무소 코드} ==!
                                return;
                            }

                            form.coTpFormList.handleSubmit(
                                () => {
                                    if (!comnUtils.isEmptyArray(coTpArray)) {
                                        coTpArray.forEach((item: any) => {
                                            if (typeof item.bsopId === "object") {
                                                item.atchFile = item.bsopId;
                                                item.bsopId = null;
                                            }

                                            if (CO_CD_LCNE_SET.has(item.coTpCd) && item.hasOwnProperty("coCdSelect")) {
                                                item.coCd = item.coCdSelect;
                                            }
                                        });
                                    } else {
                                        toast.showToast({
                                            type: "warning",
                                            content: t("msg.com.00035", { 0: t("L_CO_TP") }),
                                        }); // Please enter {0}. !== {0} 을(를) 입력하여 주세요. ==!
                                        return;
                                    }

                                    setStore(pgeUid, {
                                        coTpArray,
                                    });

                                    const usrAplyInfo = form.usrAplyInfo.getValues();

                                    const saveData = {
                                        ...usrAplyInfo,
                                        coTpList: coTpArray,
                                    };
                                    fetch.saveCoUsr.fetch(saveData);
                                },
                                () => {
                                    handler.showValidMsg();
                                },
                            )();
                        },
                        () => {
                            toast.showToast({
                                type: "warning",
                                content: t("msg.ptl.00682", { 0: t("T_CO_INFO") + " TAB" }),
                            }); // Please check the required entries for {0} !== {0}의 필수입력 항목을 확인하시기 바랍니다. ==!
                        },
                    )();
                },
            });
        },
        checkPwd: () => {
            const usrPwd = form.usrAplyInfo.getValue("usrPwd");
            const usrPwdCfrm = form.usrAplyInfo.getValue("usrPwdCfrm");

            if (!comnUtils.isEmpty(usrPwd) && !comnUtils.equals(usrPwd, usrPwdCfrm)) {
                form.usrAplyInfo.setError("usrPwdCfrm", {
                    message: "msg.ptl.00712", // Passwords do not match. !== 비밀번호가 일치하지 않습니다. ==!
                    type: "error",
                });
            } else {
                form.usrAplyInfo.clearErrors("usrPwdCfrm");
            }
        },
        checkUsrTin: () => {
            const xtrnUsrIdntfNo = form.usrAplyInfo.getValue("xtrnUsrIdntfNo");
            if (xtrnUsrIdntfNo) {
                fetch.getCoDuplCheck.fetch(xtrnUsrIdntfNo);
            } else {
                form.usrAplyInfo.clearErrors("xtrnUsrIdntfNo");
            }
        },
        showValidMsg: () => {
            let dataNm = "";
            let dataSn = "";

            const coTpArray = form.coTpFormList.getValues("coTpArray");
            coTpArray.some((item: any, idx: any) => {
                dataSn = idx + 1;
                if (comnUtils.isEmptyString(item.coTpCd) || comnUtils.isUndefined(item.coTpCd)) {
                    dataNm = t("L_CO_TP_CD"); // Company Type !== 업체 타입 ==!
                    return true;
                } else {
                    if (CO_CD_LCNE_SET.has(item.coTpCd) && item.coTpCd !== "C") {
                        if (comnUtils.isEmptyString(item.coCdSelect) || comnUtils.isUndefined(item.coCdSelect)) {
                            dataNm = t("L_CO_CD"); // Company Code !== 업체 코드 ==!
                            return true;
                        }
                    } else {
                        if (CO_CD_INPUT_TRGT_SET.has(item.coTpCd)) {
                            if (comnUtils.isEmptyString(item.coCd) || comnUtils.isUndefined(item.coCd)) {
                                dataNm = t("L_CO_CD"); // Company Code !== 업체 코드 ==!
                                return true;
                            }
                        }
                    }
                }
                if (comnUtils.isEmptyString(item.cstmOfceCd) || comnUtils.isUndefined(item.cstmOfceCd)) {
                    dataNm = t("L_CSTM_OFCE_CD"); // Customs Office Code !== 세관 사무소 코드 ==!
                    return true;
                }
            });

            toast.showToast({
                type: "warning",
                content: t("msg.cgm.00374", { 0: t("L_CO_CD") + " TAB", 1: dataNm, 2: dataSn }),
            }); // {0} : {1} [{2}] is mandatory. !== {0} : {1} [{2}] 은(는) 필수 입니다. ==!
        },
    };

    useEffect(() => {}, []);

    return (
        <Page>
            <Tab
                {...tab.tab}
                onChange={(index) => {
                    // Call the list of departments in an Organization when you click on a tab !== 신규 등록시 부서 탭 클릭시 알림 문구 출력 ==!
                    // handler.onDeptTabClick(index);
                }}
            >
                <Tab.Panel>
                    <Group>
                        <Group.Header>
                            <Group.Title title={"T_CO_INFO"} />
                        </Group.Header>
                        <Group.Body>
                            <Group.Section>
                                <Group.Row>
                                    <Group.Control
                                        {...form.usrAplyInfo.schema.coTin}
                                        rightButton={{
                                            icon: "search",
                                            onClick: () => {
                                                fetch.getTinNoLstForCo.fetch();
                                            },
                                        }}
                                    />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.usrAplyInfo.schema.coNm}></Group.Control>
                                    <Group.Control {...form.usrAplyInfo.schema.inwdCoYn}></Group.Control>
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.usrAplyInfo.schema.rprsTelno}></Group.Control>
                                    <Group.Control {...form.usrAplyInfo.schema.rprsFaxNo}></Group.Control>
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.usrAplyInfo.schema.rprsEml}></Group.Control>
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.usrAplyInfo.schema.coAddr}></Group.Control>
                                </Group.Row>
                            </Group.Section>
                        </Group.Body>
                    </Group>
                    <Group>
                        <Group.Header>
                            <Group.Title title={t("T_RPPN_INFO")} />
                        </Group.Header>
                        <Group.Body>
                            <Group.Section>
                                <Group.Row>
                                    <Group.Control
                                        {...form.usrAplyInfo.schema.xtrnUsrIdntfNo}
                                        rightButton={{
                                            icon: "search",
                                            onClick: () => {
                                                fetch.getTinNoLstForUsr.fetch();
                                            },
                                        }}
                                    />
                                    <Group.Control {...form.usrAplyInfo.schema.usrNm}></Group.Control>
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.usrAplyInfo.schema.aplcCntyCd}></Group.Control>
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.usrAplyInfo.schema.frgnrYn}></Group.Control>
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.usrAplyInfo.schema.usrMoblNo}></Group.Control>
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.usrAplyInfo.schema.usrEmlAddr}></Group.Control>
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.usrAplyInfo.schema.rsdtAddr}></Group.Control>
                                </Group.Row>
                            </Group.Section>
                        </Group.Body>
                    </Group>
                </Tab.Panel>
                <Tab.Panel>
                    <Group>
                        <Group.Header>
                            {/* Company Type */}
                            <Group.Title title={t("T_CO_TP")} />
                        </Group.Header>
                        <Group.Body>
                            {fields.map((coTp, index) => {
                                return (
                                    <Item
                                        key={coTp.key}
                                        coTp={coTp}
                                        index={index}
                                        watch={form.coTpFormList.watch}
                                        remove={remove}
                                        lcmWrhsCoTpMapRef={lcmWrhsCoTpMapRef}
                                        coTpFormList={form.coTpFormList}
                                        coTin={coTin}
                                        epzPrmss={epzPrmss}
                                        usrAplyInfo={form.usrAplyInfo}
                                    />
                                );
                            })}
                            <Layout direction="row">
                                <Layout.Right>
                                    <Button
                                        onClick={() => {
                                            append({});
                                        }}
                                    >
                                        {t("B_CO_TP_CD_ADD")}
                                    </Button>
                                </Layout.Right>
                            </Layout>
                        </Group.Body>
                    </Group>
                </Tab.Panel>
            </Tab>
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.ptli0905001q);
                        }}
                    ></Button>
                </Layout.Left>
                <Layout.Right>
                    <Button
                        role="save"
                        onClick={() => {
                            handler.onSaveBtnClick();
                        }}
                    ></Button>
                </Layout.Right>
            </Layout>
        </Page>
    );
};

const Item = (props: any) => {
    const { coTp, watch, index, remove, lcmWrhsCoTpMapRef, coTpFormList, coTin, epzPrmss, usrAplyInfo } = props;

    const [coTpCd, setCoTpCd] = useState("");
    const [coCdSelectVal, setCoCdSelectVal] = useState("");
    const [cstmOfceCd, setCstmOfceCd] = useState("");

    const { t } = useTranslation();

    const [currLcmWrhs, setCurrLcmWrhs] = useState<any>({});

    //const [currCoTin, setCurrCoTin] = useState<any>({});
    const currCoTin = useRef<any>({});

    useEffect(() => {
        const subs = watch((value: any) => {
            const curCoTpCd = value.coTpArray[index]["coTpCd"];

            setCoTpCd(curCoTpCd);
        });
        setCoTpListValue(index, "coTpNm", usrAplyInfo.getValue("coNm"));
        return () => {
            subs.unsubscribe();
        };
    }, [watch, index]);

    useEffect(() => {
        setCoTpListValue(index, "coTpNm", usrAplyInfo.getValue("coNm"));
    }, [usrAplyInfo.getValue("coNm")]);

    const getCoTpListValue = (index: any, name: any) => {
        return coTpFormList.getValue("coTpArray." + index + "." + name);
    };

    const setCoTpListValue = (index: any, name: any, value: any) => {
        coTpFormList.setValue("coTpArray." + index + "." + name, value);
    };

    const isFieldVisible = (field: string) => {
        const visibleFields = FIELD_VISIBILITY_MAP.get(coTpCd) || new Set();
        return visibleFields.has(field);
    };

    const isAtchFileVisible = (field: string) => {
        const visibleFields = ATCH_FILE_VISIBILITY_MAP.get(coTpCd) || new Set();
        return visibleFields.has(field);
    };

    const isCoCdInputTrgt = () => {
        return CO_CD_INPUT_TRGT_SET.has(coTpCd);
    };

    const isLcmWrhsSelectTrgt = (coTpCdParam: string = coTpCd) => {
        return CO_CD_LCNE_SET.has(coTpCdParam) && coTpCdParam !== "C" && coTpCdParam !== "CS";
        //return CO_CD_LCNE_SET.has(coTpCdParam) && coTpCdParam !== "C";
    };

    const findLcmsWrhs = (coTpCd: string, coCd: string) => {
        const lcmWrhsCoTpMap = lcmWrhsCoTpMapRef;
        if (lcmWrhsCoTpMap?.hasOwnProperty(coTpCd)) {
            const currLcm = lcmWrhsCoTpMap[coTpCd].find((x: any) => x.coCd === coCd);
            return currLcm || null;
        }
        return null;
    };

    const getLcmWrhsOptionArr = () => {
        let lcmWrhsCoTpOptions: any[] = [];
        const lcmWrhsCoTpMap = lcmWrhsCoTpMapRef;
        if (isLcmWrhsSelectTrgt() && lcmWrhsCoTpMap?.hasOwnProperty(coTpCd)) {
            lcmWrhsCoTpOptions = lcmWrhsCoTpMap[coTpCd]?.map((item: any) => ({
                label: item.coCd,
                value: item.coCd,
                cstmOfceCd: item.glblCstmOfceCd,
                cstmOfceCdNm: item.glblCstmOfceNm,
            }));
        }
        return lcmWrhsCoTpOptions;
    };

    const isCellGroupVisible = FIELD_VISIBILITY_MAP.get(coTpCd)?.size;

    // const isCstmOfceCdSelectableLcne = () => {
    //     return new Set(["WE", "WG", "WP"]).has(coTpCd); // EPZ LICENSE
    // };
    // coTpCd가 WE, WG, WP일 때, true 값을 출력 또는 glblCstmOfceCd가 null값이거나 빈 값이 들어올 때 true를 출력
    const isCstmOfceCdSelectableLcne = () => {
        const isEpzType = new Set(["WE", "WG", "WP"]).has(coTpCd);
        const isGlblCstmOfceCdNull = comnUtils.isEmpty(currLcmWrhs?.glblCstmOfceCd);
        // 이 조건을 만족할 때만 검색 비활성화 -> 그 외는 모두 검색 가능
        return isEpzType || isGlblCstmOfceCdNull;
    };

    const isLcneUseTpCdSelectTrgt = () => {
        return "C" === coTpCd;
    };

    const onCoTpCdChange = () => {
        setCoTpListValue(index, "cstmOfceCd", "");
        setCoTpListValue(index, "coCd", "");
        setCoTpListValue(index, "coCdSelect", "");
    };

    const onLcmWrhsCstmOfceCdChange = () => {
        if (isCstmOfceCdSelectableLcne()) {
            // EPZ 면허 보유 세관 수를 면허 수로 제한
            const epzLcnePrmssInfo = epzPrmss;
            if (!comnUtils.isUndefined(epzLcnePrmssInfo)) {
                let epzLcneCnt = epzLcnePrmssInfo.epzLcneCnt; // EPZ 면허 수
                let cstmOfceCdCnt = epzLcnePrmssInfo.cstmOfceCdCnt; // EPZ 면허 등록 세관 수
                let cstmOfceCdSet = epzLcnePrmssInfo.cstmOfceCdSet; // EPZ 면허 등록 세관
                if (epzLcneCnt > cstmOfceCdCnt) {
                    // EPZ 면허 수보다 등록된 세관 수가 적은 경우
                    return;
                }
                if (epzLcneCnt >= 1 && epzLcneCnt == cstmOfceCdCnt) {
                    // 면허 1개 이상 발급 && EPZ 면허 수와 등록된 세관 수가 동일한 경우
                    if (!comnUtils.isUndefined(cstmOfceCd) && !comnUtils.isEmptyString(cstmOfceCd)) {
                        // 기존에 등록된 세관을 포함하는 경우
                        if (cstmOfceCdSet.includes(cstmOfceCd)) {
                            return;
                        }
                    }
                }
            }
            setCoTpListValue(index, "cstmOfceCd", currLcmWrhs.glblCstmOfceCd);
        } else {
            setCoTpListValue(index, "cstmOfceCd", currLcmWrhs.glblCstmOfceCd);
        }
    };

    const onLcmWrhsCoCdSlctChange = () => {
        let bfrCoCdSelect = "";
        if (currLcmWrhs?.hasOwnProperty("coCd")) {
            bfrCoCdSelect = currLcmWrhs.coCd;
        }

        const cstmOfceCd = getCoTpListValue(index, "cstmOfceCd");
        const coCdSelect = getCoTpListValue(index, "coCdSelect");
        if (isLcmWrhsSelectTrgt(coTpCd)) {
            const currLcm = findLcmsWrhs(coTpCd, coCdSelect);
            if (!!currLcm) {
                if (bfrCoCdSelect !== currLcm?.coCd) {
                    if (currLcm.glblCstmOfceCd !== cstmOfceCd) {
                        setCoTpListValue(index, "cstmOfceCd", currLcm.glblCstmOfceCd);
                    }
                    setCurrLcmWrhs(currLcm);
                }
            } else {
                if (!!getCoTpListValue(index, "cstmOfceCd")) {
                    setCoTpListValue(index, "cstmOfceCd", "");
                }

                if (!!coTin && coTin !== currCoTin.current) {
                    if (!!getCoTpListValue(index, "coCdSelect") || !!coCdSelect) {
                        setCoTpListValue(index, "coCdSelect", "");
                        setCoTpListValue(index, "coCd", "");
                    }
                    currCoTin.current = coTin;
                }

                setCurrLcmWrhs({});
            }
        } else {
            if (Object.keys(currLcmWrhs).length !== 0) {
                setCoTpListValue(index, "coCdSelect", "");
                setCoTpListValue(index, "coCd", "");
            }
            setCurrLcmWrhs({});
        }
    };

    return (
        <>
            <Group.Section key={coTp.key}>
                <Group.Row>
                    <Group.Control
                        {...coTp.schema.coTpCd}
                        excludes={CO_CD_EXCL_SET}
                        onChange={() => onCoTpCdChange()}
                    />

                    {!isLcmWrhsSelectTrgt() ? (
                        <Group.Control {...coTp.schema.cstmOfceCd}></Group.Control>
                    ) : (
                        <Group.Control
                            {...coTp.schema.cstmOfceCd}
                            disableSearch={!isCstmOfceCdSelectableLcne()}
                            readOnlyInput={!isCstmOfceCdSelectableLcne()}
                            borderColor={!isCstmOfceCdSelectableLcne() ? "info" : ""}
                            onChange={() => onLcmWrhsCstmOfceCdChange()}
                        />
                    )}
                </Group.Row>
                <Group.Row>
                    {!isLcmWrhsSelectTrgt() && isCoCdInputTrgt() && (
                        <Group.Control
                            {...coTp.schema.coCd}
                            maxLength={CO_CD_INPUT_PROPERTIES[coTpCd].maxLength}
                            placeholder={CO_CD_INPUT_PROPERTIES[coTpCd].placeholder}
                        ></Group.Control>
                    )}
                    {!isLcmWrhsSelectTrgt() && !isCoCdInputTrgt() && (
                        <Group.Control {...coTp.schema.coCdRo}></Group.Control>
                    )}
                    {isLcmWrhsSelectTrgt() && (
                        <Group.Control
                            {...coTp.schema.coCdSelect}
                            options={getLcmWrhsOptionArr()}
                            onChange={() => onLcmWrhsCoCdSlctChange()}
                        />
                    )}
                    {isLcneUseTpCdSelectTrgt() && <Group.Control {...coTp.schema.lcneUseTpCd}></Group.Control>}
                </Group.Row>

                {/* Company Name 입력   WB, WE, WF에서 문제가 발생*/}
                <Group.Row>
                    {!isLcmWrhsSelectTrgt() && isCoCdInputTrgt() && (
                        <Group.Control {...coTp.schema.coTpNm}></Group.Control>
                    )}
                    {/* WA, WC, WD 선택 시*/}
                    {!isLcmWrhsSelectTrgt() && !isCoCdInputTrgt() && (
                        <Group.Control {...coTp.schema.coTpNm}></Group.Control>
                    )}
                    {/* WB, WE, WF 선택 시 */}
                    {isLcmWrhsSelectTrgt() && <Group.Control {...coTp.schema.coTpNm} />}
                    {/* {isLcneUseTpCdSelectTrgt() && (  ->> Company Type CRA 일 때, 출력되는 License Type Code
                        <Group.Control {...coTp.schema.lcneUseTpCd}></Group.Control>
                    )} */}
                </Group.Row>

                {isCellGroupVisible != null && isCellGroupVisible > 0 && (
                    <Group.Row>
                        {isFieldVisible("gainCfrmOmsnYn") && (
                            <Group.Control {...coTp.schema.gainCfrmOmsnYn}></Group.Control>
                        )}
                        {isFieldVisible("gaotCfrmOmsnYn") && (
                            <Group.Control {...coTp.schema.gaotCfrmOmsnYn}></Group.Control>
                        )}
                        {isFieldVisible("stckCretCtraTpCd") && (
                            <Group.Control {...coTp.schema.stckCretCtraTpCd}></Group.Control>
                        )}
                        {isFieldVisible("stckClarCtraTpCd") && (
                            <Group.Control {...coTp.schema.stckClarCtraTpCd}></Group.Control>
                        )}
                    </Group.Row>
                )}
                {isCellGroupVisible != null && isCellGroupVisible > 0 && (
                    <Group.Row>
                        {isFieldVisible("autoCriYn") && <Group.Control {...coTp.schema.autoCriYn}></Group.Control>}
                        {isFieldVisible("autoCroYn") && <Group.Control {...coTp.schema.autoCroYn}></Group.Control>}
                        {isFieldVisible("wrhsDpstDays") && (
                            <Group.Control {...coTp.schema.wrhsDpstDays}></Group.Control>
                        )}
                        {isFieldVisible("psnWrhsYn") && <Group.Control {...coTp.schema.psnWrhsYn}></Group.Control>}
                        {isFieldVisible("spcdlWrhsYn") && <Group.Control {...coTp.schema.spcdlWrhsYn}></Group.Control>}
                        {isFieldVisible("rskCagYn") && <Group.Control {...coTp.schema.rskCagYn}></Group.Control>}
                    </Group.Row>
                )}
                {isAtchFileVisible("bsopId") && (
                    <Group.Row>
                        <Group.Control {...coTp.schema.bsopId} controlSize={10} />
                    </Group.Row>
                )}
            </Group.Section>
            <Layout>
                <Layout.Right>
                    <Button
                        role="delete"
                        onClick={() => {
                            remove(index);
                        }}
                    >
                        {t("B_DEL")}
                    </Button>
                </Layout.Right>
            </Layout>
        </>
    );
};
